import React, { useState, useEffect } from 'react';
import { checkHealth } from '../services/api';

function HealthCheck() {
  const [health, setHealth] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHealth = async () => {
      try {
        setLoading(true);
        const data = await checkHealth();
        setHealth(data);
        setError(null);
      } catch (err) {
        setError(err.message);
        setHealth(null);
      } finally {
        setLoading(false);
      }
    };

    fetchHealth();
    // Refresh every 30 seconds
    const interval = setInterval(fetchHealth, 30000);
    return () => clearInterval(interval);
  }, []);

  const getStatusIndicator = (serviceStatus) => {
    if (serviceStatus === 'connected' || serviceStatus === 'available') {
      return 'healthy';
    }
    if (serviceStatus && serviceStatus.startsWith('error')) {
      return 'unhealthy';
    }
    return 'warning';
  };

  return (
    <div className="health-check">
      <h2>System Health</h2>
      {loading && <div className="loading">Checking health...</div>}
      {error && <div className="error">Error: {error}</div>}
      {health && (
        <div>
          <div className="health-status">
            <span
              className={`status-indicator ${
                health.status === 'healthy' ? 'healthy' : 'unhealthy'
              }`}
            ></span>
            <strong>Overall Status: {health.status}</strong>
          </div>
          {health.services && (
            <div style={{ marginTop: '1rem' }}>
              {Object.entries(health.services).map(([service, status]) => (
                <div key={service} className="health-status">
                  <span
                    className={`status-indicator ${getStatusIndicator(status)}`}
                  ></span>
                  <span>
                    <strong>{service}:</strong> {status}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default HealthCheck;
